import partnerService from 'services/partnerService';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Employee } from 'types/Partner';

interface PartnerFormState {
  tabIndex: string;
  thRm: Employee[];
  showSecondLevelTabs: boolean;
}

export const initialPartnerFormState: PartnerFormState = {
  tabIndex: 'core-data',
  thRm: [],
  showSecondLevelTabs: true,
};

export const fetchthRm = createAsyncThunk(
  'PARTNER_FORM/fetchthRm',
  async (args: { userID: string; loadAllEmployees: any }, thunkAPI) => {
    try {
      if (args.loadAllEmployees) {
        return (await partnerService.getAllAvailableThRmRma()) || [];
      } else {
        return (await partnerService.getThRm(args.userID)) || [];
      }
    } catch (error) {
      return thunkAPI.rejectWithValue((error as any).response);
    }
  },
);

const partnerFormSlice = createSlice({
  name: 'PARTNER_FORM',
  initialState: initialPartnerFormState,
  reducers: {
    setThRm: (state, action: PayloadAction<Employee[]>) => {
      return { ...state, thRm: action.payload };
    },
    setTabId: (state, action: PayloadAction<string>) => {
      return { ...state, tabIndex: action.payload };
    },
    setShowSecondLevelTabs: (state, action: PayloadAction<boolean>) => {
      return { ...state, showSecondLevelTabs: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchthRm.fulfilled, (state, action) => {
      return { ...state, thRm: action.payload };
    });
  },
});

export const { setThRm, setTabId, setShowSecondLevelTabs } = partnerFormSlice.actions;

export default partnerFormSlice.reducer;
